import useSWR from "swr";

import { fetchSocialShareCount } from "./apis";

export function useSocialShareCount(relativeUrl: string) {
  const { data } = useSWR([relativeUrl, `/social-share-count/${relativeUrl}`], ([relativeUrl]) =>
    fetchSocialShareCount(relativeUrl),
  );

  return data ?? 0;
}
